export enum Locales {
  EN = 'en',
  DE = 'de',
}

export const LOCALES = [
  { value: Locales.EN, caption: 'English' },
  { value: Locales.DE, caption: 'Deutsch' }
]
